/*
 * Filename: ChannelItem.tsx
 * Path: SEL
 * Created Date: Thursday, June 29th 2023, 2:15:58 pm
 * Author: Eduardo Yair Cuellar Rivera
 *
 * Copyright (c) 2023 Sky
 */

import { Channel, ChannelBox, ChannelLogo } from 'planby';
import { Row } from 'react-bootstrap';

interface ChannelItemProps {
  channel: Channel;
}

export const ChannelItem = ({ channel }: ChannelItemProps) => {
  const { position, logo, canal,provider } = channel;
  return (
    <ChannelBox
      {...position}
      style={{
        boxShadow: '0 0 30px rgba(0,0,0,0.75)',
        clipPath: 'inset(2px -50px 2px 0px)',
        borderBottom: '3px solid #cdcdcd',
      }}
    >
      {/* Overwrite styles by add eg. style={{ maxHeight: 52, maxWidth: 52,... }} */}
      {/* Or stay with default styles */}
      <div className="flex flex-row items-center align-middle text-center gap-x-2">
        <div className="flex flex-col text-secondary text-sm">
          <Row><span>Canal</span></Row>
          <Row><span>{provider}</span></Row>
        </div>
        <ChannelLogo src={logo} alt="" style={{ maxHeight: 40, maxWidth: 40 }} />
      </div>
    </ChannelBox>
  );
};
